<template>
    <n-modal :show="openInvoicedModal" preset="card" title="Dialog" size="small" :style="ModalStyle()">
        <template #header>
            <div>{{status}} Item Request</div>
        </template>
        <div v-if="isResponsePageShow == false">
            <n-form ref="formRef" :model="customerAction">
                    <n-grid cols="1 450:4">
                        <n-grid-item>
                            <div class="item_img">
                                <img v-if="data.img_url !== '#'" :src="data.img_url" :alt="data.sku" style="width:80px;height:80Px">
                                <n-icon v-else size="80">
                                    <Image />
                                </n-icon>
                            </div>
                        </n-grid-item>
                        <n-grid-item span="3">
                            <div class="item_details">
                                <div>{{data.sales_desc}}</div>
                                <div style="font-size:11px"> {{data.sku}} &nbsp; &nbsp;&nbsp; ${{data.price}}</div>
                                <div style="width:150px; display: inline-block">
                                    <n-input-number  v-model:value="customerAction.uploadQty" size="small" :min="0" :max="customerAction.defaultQty" />
                                </div>
                            </div>
                        </n-grid-item>
                    </n-grid>
                    
                    <n-form-item path="command">
                        <n-input v-model:value="customerAction.command" type="textarea" placeholder="Please leave your message (optional)" :autosize="{ minRows: 3, maxRows: 3 }"/>
                    </n-form-item>
                    <n-space justify="end">
                            <n-button size="small" type="info" @click="handleValidateClick" attr-type="button" :disabled="isSubmitBtnLoading === true" :loading="isSubmitBtnLoading === true">Submit</n-button>
                            <n-button size="small" @click="closeModal" :disabled="isSubmitBtnLoading === true">Cancel</n-button>
                    </n-space>
            </n-form>
        </div>
        <div v-else>
            <n-result status="success" title="Success" v-if="responseStatus == 'success'">
                <template #default>
                <div style="text-align:center; line-height:0.8">
                    <p>Your request <b>#91235</b> has been successfully sent. </p>
                    <p>You will receive an email notification shortly.</p>
                    <p>Our customer care team will contact you within the next 48 hours</p>
                </div>
                </template>
                <template #footer>
                    <n-button type="info" @click="closeModal">OK</n-button>
                </template>
            </n-result>

            <n-result status="error" title="Request Failed" description="Please Try again. Thank you (^u^)" v-if="responseStatus == 'error'">
                <template #footer>
                    <n-button type="error" ghost @click="closeModal">OK</n-button>
                </template>
            </n-result>
        </div>
    </n-modal>
</template>

<script>
import {NModal, NButton, NInput, NGrid, NGridItem, NSpace, NForm, NFormItem, NInputNumber, NResult, NIcon} from "naive-ui"
import {ref} from "vue"
import { Image } from '@vicons/ionicons5'


export default{
    name:"InvoiceModal",
    props:["openInvoicedModal","data", "status","salesorderDetails"],
    components:{
        NModal,
        NButton,
        NInput,
        NGrid,
        NGridItem,
        NSpace,
        NForm, 
        NFormItem,
        NInputNumber,
        NResult,
        NIcon,
        Image
    },
    setup(props, {emit}){
        const formRef = ref(null)
        const isSubmitBtnLoading = ref(false)
        const isResponsePageShow = ref(false)
        const responseStatus = ref(null)
        const customerAction = ref({
            defaultQty:props.data.qty,
            uploadQty: 0,
            command:""
        })
        console.log(props,"props..Invoiced")
        
        const closeModal = () =>{
            emit('close')
            customerAction.value = null
        }

        const handleValidateClick  = () => {
            formRef.value.validate((errors) => {
            if (!errors) {
                console.log("customer commamd: ", customerAction.value.command)
                console.log("item status: ", props.status )
                console.log("item data", props.data)
                console.log(props.salesorderDetails)

                isSubmitBtnLoading.value = true
                isResponsePageShow.value = true
                responseStatus.value = "error"

                const description = `
                    Order Ref: ${props.data.refnumber}

                    Sku: ${props.data.sku}

                    Qty: ${customerAction.value.uploadQty}

                    Message(optional): ${customerAction.value.command}
                `

                var ticketFormdata = new FormData()
                
                ticketFormdata.append("name", props.salesorderDetails.billpersonfullname)
                ticketFormdata.append("phone", props.salesorderDetails.billpersonmobile)
                ticketFormdata.append("email", props.salesorderDetails.customeremail)
                ticketFormdata.append("description", description)
                ticketFormdata.append("priority",3)
                ticketFormdata.append("status",2)
                ticketFormdata.append("source",100)
                ticketFormdata.append("group_id", 51000167264) 

                if(props.status == "Damaged"){
                    ticketFormdata.append("subject", `Damaged Item - ${props.data.refnumber} - ${props.data.sku} X ${customerAction.value.uploadQty}`)
                    console.log("call API for damaged")
                    for(let pair of ticketFormdata.entries()) {
                        console.log(pair[0]+ ', '+ pair[1]); 
                    }
                }

                if(props.status == "Missing"){
                    ticketFormdata.append("subject", `Missing Item - ${props.data.refnumber} - ${props.data.sku} X ${customerAction.value.uploadQty}`)
                    console.log("call API for missing")
                    for(let pair of ticketFormdata.entries()) {
                        console.log(pair[0]+ ', '+ pair[1]); 
                    }
                }

                if(props.status == "Wrong"){
                    ticketFormdata.append("subject", `Return Item - ${props.data.refnumber} - ${props.data.sku} X ${customerAction.value.uploadQty}`)
                    console.log("call API for wrong")
                    for(let pair of ticketFormdata.entries()) {
                        console.log(pair[0]+ ', '+ pair[1]); 
                    }
                }
            } else {
                console.log(errors)
            }
            })
        }

        const ModalStyle = () =>{
            if(document.body.clientWidth < 764) return "width:80%"
            if(document.body.clientWidth >= 764) return "width:500px"
        }

        // const modalSize = computed()
        return{
            formRef,
            isSubmitBtnLoading,
            isResponsePageShow,
            responseStatus,
            customerAction,
            closeModal,
            ModalStyle,
            // rules: {
            //     command: {
            //         required: true,
            //         message: 'Please leave you message',
            //         trigger: ['input']
            //     }
            // },
            handleValidateClick
        }
    },
}
</script>

<style scoped>

@media only screen and (max-width: 620px) {
  .item_img{
      text-align: center
  }

  .item_details{
      text-align: center
  }
}
</style>